import { createContext, useContext, type ReactNode } from 'react'
import { useCookieConsent, type UseCookieConsentReturn } from '@/hooks/useCookieConsent'

const CookieConsentContext = createContext<UseCookieConsentReturn | null>(null)

export function CookieConsentProvider({ children }: { children: ReactNode }) {
  const consent = useCookieConsent()

  return (
    <CookieConsentContext.Provider value={consent}>{children}</CookieConsentContext.Provider>
  )
}

export function useCookieConsentContext(): UseCookieConsentReturn {
  const ctx = useContext(CookieConsentContext)
  if (!ctx) {
    throw new Error('useCookieConsentContext must be used within CookieConsentProvider')
  }
  return ctx
}
